import { render, staticRenderFns } from "./quesSuccess2.vue?vue&type=template&id=26a05d39"
import script from "./quesSuccess2.vue?vue&type=script&lang=js"
export * from "./quesSuccess2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports